import SimLogo from './SimLogo';

export default SimLogo;
